import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';

const ForgotPassword = () => {
  const [emailSent, setEmailSent] = useState(false);

  const validationSchema = Yup.object({
    email: Yup.string()
      .email('Invalid email address')
      .required('Required'),
  });

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema,
    onSubmit: (values) => {
      // In a real app, you would make an API call here
      console.log('Password reset requested for:', values.email);
      toast.success('Password reset link sent to your email!');
      setEmailSent(true);
    },
  });

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#e6efe6] bg-opacity-90">
      <div className="max-w-md w-full space-y-8 p-8 bg-white/80 rounded-lg backdrop-blur-sm">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-2">Housing Bank</h1>
          <h2 className="text-xl text-gray-600">Reset Password</h2>
        </div>

        {!emailSent ? (
          <form onSubmit={formik.handleSubmit} className="mt-8 space-y-6">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email Address
              </label>
              <input
                id="email"
                type="email"
                {...formik.getFieldProps('email')}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500"
                placeholder="Enter your email"
              />
              {formik.touched.email && formik.errors.email ? (
                <div className="text-red-500 text-sm mt-1">{formik.errors.email}</div>
              ) : null}
            </div>

            <div>
              <button
                type="submit"
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-800 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
              >
                Send Reset Link
              </button>
            </div>
          </form>
        ) : (
          <div className="mt-8 text-center">
            <div className="text-green-600 mb-4">
              Password reset link has been sent to your email!
            </div>
            <p className="text-gray-600 mb-4">
              Please check your email and follow the instructions to reset your password.
            </p>
          </div>
        )}

        <div className="text-sm text-center">
          <Link to="/login" className="text-green-600 hover:text-green-500">
            Back to Sign In
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;